import { Box } from '@mui/material';
import BusinessProfileLayout from 'layouts/ProfileLayout/BusinessProfileLayout';
import { IUserProfileData } from '../../../../interfaces/profile.interface';
import TabPanel from '../../../tabs/TabPanel';
import BusinessHomeWallTab from '../business/BusinessHomeWallTab';
import BusinessInfo from '../business/BusinessInfo';
import { BusinessProfileProvider } from '../business/BusinessProfileModeProvider';

const BusinessProfileMode = ({ initData }: { initData: IUserProfileData }) => {
  return (
    <BusinessProfileProvider initData={initData}>
      <BusinessProfileLayout>
        <BusinessInfo />
        <Box sx={{ width: '100%' }}>
          <TabPanel index={0} value={0}>
            <BusinessHomeWallTab />
          </TabPanel>
        </Box>
      </BusinessProfileLayout>
    </BusinessProfileProvider>
  );
};

export default BusinessProfileMode;
